import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { isServer } from 'tradera-utils/nextjs';
import { getErrorMessage } from 'tradera-backend/utils/error';

let log;

(async () => {
    if (isServer) {
        const { Logger } = await import(
            '@tradera-internal/infrastructure-logging'
        );
        log = new Logger('ApplicationErrorBoundary');
    }
})();

class ApplicationErrorBoundary extends React.Component {
    componentDidCatch() {}

    onError(error) {
        const { capture = true } = this?.props || {};
        if (typeof capture === 'function') {
            capture(error);
        }
        if (isServer && log) {
            const errorMessage = getErrorMessage(error);
            log.error(
                errorMessage,
                {
                    source: 'react ApplicationErrorBoundary'
                },
                error
            );
        }
    }

    render() {
        const { children, fallback, capture } = this.props;

        if (!capture) {
            return children;
        }

        return (
            <Sentry.ErrorBoundary
                fallback={fallback}
                onError={error => this.onError(error)}>
                {children}
            </Sentry.ErrorBoundary>
        );
    }
}

ApplicationErrorBoundary.propTypes = {
    // Capture function, if false then errors are silently ignored
    capture: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    fallback: PropTypes.node
};

ApplicationErrorBoundary.defaultProps = {
    capture: true,
    fallback: null
};

export default ApplicationErrorBoundary;
